module.exports = __webpack_public_path__ + "aeeee4fc796d29370ef175f2e11744b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/checkedbox.png
// module id = 116
// module chunks = 0